<script setup lang="ts" generic="T extends string">
defineProps<{
  options: { label: string; value: T }[]
  modelValue: T
}>()

const emit = defineEmits<{
  'update:modelValue': [T]
}>()

function pick(v: T) {
  emit('update:modelValue', v)
}
</script>

<template>
  <div class="seg" role="tablist">
    <button
      v-for="o in options"
      :key="o.value"
      type="button"
      role="tab"
      :data-active="o.value === modelValue ? '1' : '0'"
      @click="pick(o.value)"
    >
      {{ o.label }}
    </button>
  </div>
</template>

<style scoped>
.seg {
  display: inline-flex;
  background: var(--bg-2);
  border-radius: var(--r-ctrl);
  padding: 2px;
  gap: 2px;
}
.seg button {
  border: none;
  background: transparent;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: var(--fs-13);
  color: var(--muted);
  cursor: pointer;
  transition: background 120ms, color 120ms;
}
.seg button:hover { color: var(--ink-2); }
.seg button[data-active='1'] {
  background: var(--surface);
  color: var(--ink);
  box-shadow: var(--shadow-1);
}
</style>
